<template>
    <div>
        <!-- ProfessionalService Schema -->
        <script type="application/ld+json" v-html="professionalServiceSchema"></script>
        
        <!-- Organization Schema -->
        <script type="application/ld+json" v-html="organizationSchema"></script>
        
        <!-- WebSite Schema -->
        <script type="application/ld+json" v-html="websiteSchema"></script>
    </div>
</template>

<script>
export default {
    name: 'StructuredData',
    computed: {
        professionalServiceSchema() {
            return JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'ProfessionalService',
                name: 'Web Services and More',
                alternateName: 'WSAM',
                url: 'https://www.wsam.biz',
                logo: 'https://www.wsam.biz/img/wsam-logo.png',
                description: 'Professionelle Webentwicklung, Full Stack Development, WordPress, E-Commerce und App-Entwicklung im DACH-Raum mit über 15 Jahren Erfahrung.',
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: 'Ginsterweg 6',
                    addressLocality: 'Pinneberg',
                    postalCode: '25421',
                    addressCountry: 'DE',
                },
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: '53.6533',
                    longitude: '9.7989',
                },
                telephone: '+49-4101-8317091',
                email: 'chhaaks@wsam.biz',
                priceRange: '€€',
                areaServed: [
                    {
                        '@type': 'Country',
                        name: 'Deutschland',
                    },
                    {
                        '@type': 'Country',
                        name: 'Österreich',
                    },
                    {
                        '@type': 'Country',
                        name: 'Schweiz',
                    },
                ],
                serviceType: [
                    'Webentwicklung',
                    'Full Stack Development',
                    'WordPress Entwicklung',
                    'E-Commerce Entwicklung',
                    'App Entwicklung',
                    'Progressive Web Apps',
                    'API Entwicklung',
                    'Softwarearchitektur',
                    'KI-gestützte Entwicklung',
                ],
                founder: {
                    '@type': 'Person',
                    name: 'Christoph Haaks',
                    jobTitle: 'CEO',
                },
                sameAs: ['https://www.wsam.biz'],
                aggregateRating: {
                    '@type': 'AggregateRating',
                    ratingValue: '5',
                    reviewCount: '50',
                },
            });
        },
        organizationSchema() {
            return JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Organization',
                name: 'Web Services and More',
                url: 'https://www.wsam.biz',
                logo: 'https://www.wsam.biz/img/wsam-logo.png',
                contactPoint: {
                    '@type': 'ContactPoint',
                    telephone: '+49-4101-8317091',
                    contactType: 'customer service',
                    areaServed: ['DE', 'AT', 'CH'],
                    availableLanguage: ['German', 'English'],
                },
            });
        },
        websiteSchema() {
            return JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                name: 'Web Services and More',
                url: 'https://www.wsam.biz',
                potentialAction: {
                    '@type': 'SearchAction',
                    target: 'https://www.wsam.biz/?s={search_term_string}',
                    'query-input': 'required name=search_term_string',
                },
            });
        },
    },
}
</script>
